// jshint esversion: 6

export default {
  types: state => state.types,
  typesMap: state => state.typesMap,
  ratesByTypeMap: state => state.ratesByTypeMap
};
